import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from '@angular/material/dialog';
import {
  SharedHttpRequestService,
  tagsViewContext,
} from '../../../../../core/lists/_services/shared-http-request.service';
import { CommunicationsService, TaskService } from '../../../../../core/timeline/_services';
import {
  ContactsService,
  DrugService,
  PatientsService,
  ViewContext,
} from '../../../../../core/lists';
import { forkJoin, of } from 'rxjs';
import { groupBy, mapValues, omit } from 'lodash-es';
import { ActivatedRoute, Router } from '@angular/router';
import { TaskHistoryComponent } from '../../../../partials/content/general/task-history/task-history.component';
import { TaskCommentsComponent } from '../../../../partials/content/general/task-comments/task-comments.component';
import { UserService } from '../../../../../core/auth/_services';
import { PatientModReviewComponent } from '../../lists/patients/patient-mod-review/patient-mod-review.component';
import { ContactHistoryReviewComponent } from '../../lists/contacts/contact-history-review/contact-history-review.component';
import { WorkflowService } from '../../../workflow/_services/workflow.service';
import { WorkflowModReviewComponent } from '../../../workflow/workflow-mod-review/workflow-mod-review.component';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'kt-view-communication',
  templateUrl: './view-communication.component.html',
  styleUrls: ['./view-communication.component.scss'],
})
export class ViewCommunicationComponent implements OnInit {
  attachmentData = {};
  tags = [];
  loadingTags = true;
  session;
  entitiesObj = [];
  contactsObj = [];
  drugsObj = [];
  entitiesGroupObj = {};
  private returnUrl: string;
  apps = [];

  /**
   * Component constructor
   *
   * @param dialogRef
   * @param router
   * @param datepipe
   * @param communicationsService
   * @param activatedRoute
   * @param sharedHttpRequestService
   * @param taskService
   * @param workflowService
   * @param cdr
   * @param contactsService
   * @param drugsService
   * @param userService
   * @param patientService
   * @param dialog
   * @param data
   */

  constructor(
    public dialogRef: MatDialogRef<ViewCommunicationComponent>,
    private router: Router,
    public datepipe: DatePipe,
    private communicationsService: CommunicationsService,
    private activatedRoute: ActivatedRoute,
    private sharedHttpRequestService: SharedHttpRequestService,
    private userService: UserService,
    private taskService: TaskService,
    private patientService: PatientsService,
    private workflowService: WorkflowService,
    private cdr: ChangeDetectorRef,
    private contactsService: ContactsService,
    private drugsService: DrugService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.returnUrl = params.returnUrl || '/';
    });
    if (data && data.type === 'session') {
      this.session = data.session;
    }
  }

  ngOnInit() {
    this.communicationsService.getApps().subscribe((res) => {
      this.apps = res;
    });
    if (this.data && this.data.session) {
      if (this.session.logs) {
        this.getAllExistEntities();
      }
      return;
    }
    if (
      this.data &&
      (this.data.received_id ||
        this.data.communicationType === 'REPLY' ||
        this.data.communicationType === 'RECEIVED')
    ) {
      this.attachmentData = {
        received_id: this.data.id,
        type: this.data.received_id ? 'RECEIVED' : this.data.communicationType,
        contact_id: this.data.contactId,
      };
    } else if (this.data) {
      this.attachmentData = { communication_id: this.data.id, type: this.data.communicationType };
    }
    if (this.data.received_id) return;
    this.sharedHttpRequestService
      .getTagsForView(this.data.id, tagsViewContext.COMMUNICATION)
      .subscribe((tags) => {
        this.tags = tags.data;
        this.loadingTags = false;
      });
  }

  getTitle() {
    if (this.session) return 'Session Information';
    return 'Communication Information';
  }

  getMiniTitle() {
    if (this.session) {
      let current = '<div class="d-flex align-items-center flex-wrap">';
      if (this.data.userName) {
        current += '<span class="text-muted mr-3 font-weight-bold font-size-sm">';
        current += 'By: ' + this.data.userName;
        current += ' </span>';
      }
      if (this.data.fromDate) {
        current += '<span class="text-muted mr-3 font-weight-bold font-size-sm">';
        current += 'Started: ' + this.data.fromDate;
        current += ' </span>';
      }
      if (this.data.toDate) {
        current += '<span class="text-muted mr-3 font-weight-bold font-size-sm">';
        current += 'Ended: ' + this.data.toDate;
        current += ' </span>';
      }
      if (this.data.duration) {
        current += '<span class="text-muted mr-3 font-weight-bold font-size-sm">';
        current += 'Duration: ' + this.data.duration + 'mins';
        current += ' </span>';
      }
      return current + ' </div>';
    }
    return 'Communication Information';
  }

  getAllExistEntities() {
    let relatedTo = [];
    const _entityIds = [];
    const _contactIds = [];
    const _drugIds = [];
    this.session.logs.forEach((log) => {
      relatedTo = relatedTo.concat(log.related_to);
    });
    if (relatedTo.length > 0) {
      relatedTo.forEach((related) => {
        if (related.type === 'ENTITY') {
          _entityIds.push(related.related_id);
        }
        if (related.type === 'CONTACT') {
          _contactIds.push(related.related_id);
        }
        if (related.type === 'DRUG') {
          _drugIds.push(related.related_id);
        }
      });
    }
    forkJoin({
      requestOne: _entityIds.length > 0 ? this.taskService.getEntities(_entityIds) : of([]),
      requestTwo:
        _contactIds.length > 0 ? this.contactsService.getContactsByIds(_contactIds) : of([]),
      requestThree: _drugIds.length > 0 ? this.drugsService.getDrugsByIds(_drugIds) : of([]),
    }).subscribe(({ requestOne, requestTwo, requestThree }) => {
      if (requestOne.data) {
        this.entitiesObj = [];
        this.entitiesGroupObj = [];
        this.entitiesObj = requestOne.data;
        this.entitiesGroupObj = mapValues(groupBy(this.entitiesObj, 'entity_type'), (list) =>
          list.map((type) => omit(type, 'entity_type')),
        );
      }
      if (requestTwo.data)
        requestTwo.data.forEach((element) => {
          this.contactsObj.push(element);
          this.entitiesGroupObj['CONTACT'] = this.contactsObj;
        });
      if (requestThree.data)
        requestThree.data.forEach((element) => {
          this.drugsObj.push(element);
          this.entitiesGroupObj['DRUG'] = this.drugsObj;
        });
      this.cdr.detectChanges();
    });
  }

  mapArray(entities, type) {
    const res = [];
    if (!entities) {
      return res;
    } else {
      entities.forEach((item) => {
        if (!Object.prototype.hasOwnProperty.call(this.entitiesGroupObj, type)) return;
        const entity = this.entitiesGroupObj[type].find((e) => e.id === item.related_id);
        if (entity) res.push(entity);
      });
      return res;
    }
  }

  getTip(last, first) {
    let res = '';
    if (last) {
      res = res + last;
    }
    if (first) {
      res = res + ' ' + first;
    }
    return res;
  }

  async openDialog(event, log) {
    event.stopPropagation();

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.closeOnNavigation = true;

    switch (log.entity_type) {
      case 'TASK':
        dialogConfig.width = '95vw';
        dialogConfig.maxWidth = '95vw';
        dialogConfig.data = { taskId: log.entity_id, version: log.version };

        this.dialog.open(TaskHistoryComponent, dialogConfig);
        break;

      case 'TASK_COMMENT': {
        const taskCommentResponse =
          log.entity_id && log.version >= 0
            ? await this.taskService
                .getCommentHistoryByVersion(log.entity_id, log.version)
                .toPromise()
            : { data: [] };
        const taskCommentHistory = taskCommentResponse.data;
        const taskCommentHistoryLength = taskCommentHistory.length;

        if (!taskCommentHistoryLength) break;

        const taskUserResponse = this.data.userName
          ? await this.userService.getUserByUserName([this.data.userName]).toPromise()
          : { pageOfItems: [] };
        const taskUser = taskUserResponse.pageOfItems.length && taskUserResponse.pageOfItems[0];

        taskCommentHistory.forEach((record) => {
          record.profileUrl = taskUser ? taskUser.profileUrl : '';
        });

        const isUpdateTaskComment =
          log.action_type === 'UPDATE' && log.version > 0 && taskCommentHistoryLength > 1;

        dialogConfig.width = '400px';
        dialogConfig.data = isUpdateTaskComment
          ? [taskCommentHistory[0], taskCommentHistory[1]]
          : log.action_type === 'CREATE'
          ? [taskCommentHistory.find((record) => record.rev_type === 'ADD')]
          : [taskCommentHistory.find((record) => record.rev_type === 'DEL')];

        this.dialog.open(TaskCommentsComponent, dialogConfig);
        break;
      }
      case 'WORKFLOW_QUEUE':
      case 'ACTION_QUEUE': {
        const wqResponse =
          log.entity_id && log.entity_type && log.version >= 0
            ? await this.workflowService
                .getHistoryByVersion(log.entity_id, log.entity_type, log.version)
                .toPromise()
            : { data: [] };
        const wqHistory = wqResponse.data;
        const wqHistoryLength = wqHistory.length;

        if (!wqHistoryLength) break;

        const isUpdateWQ =
          (log.action_type === 'UPDATE' || log.action_type === 'CHANGE_STATUS') &&
          wqHistoryLength > 1;

        wqHistory.forEach((record) => {
          record.name = log.name;
          record.form_schema =
            typeof record.form_schema === 'string'
              ? JSON.parse(record.form_schema)
              : record.form_schema;
          record.input_data =
            typeof record.input_data === 'string'
              ? { data: JSON.parse(record.input_data) }
              : { data: record.input_data };
        });

        dialogConfig.width = isUpdateWQ ? '90vw' : '45vw';
        dialogConfig.data = isUpdateWQ ? [wqHistory[0], wqHistory[1]] : [wqHistory[0]];

        this.dialog.open(WorkflowModReviewComponent, dialogConfig);
        break;
      }
      case 'WORKFLOW_COMMENT': {
        const wqCommentResponse =
          log.entity_id && log.entity_type && log.version >= 0
            ? await this.workflowService
                .getHistoryByVersion(log.entity_id, log.entity_type, log.version)
                .toPromise()
            : { data: [] };
        const wqCommentHistory = wqCommentResponse.data;
        const wqCommentHistoryLength = wqCommentHistory.length;

        if (!wqCommentHistoryLength) break;

        const wqUserResponse = this.data.userName
          ? await this.userService.getUserByUserName([this.data.userName]).toPromise()
          : { pageOfItems: [] };
        const wqUser = wqUserResponse.pageOfItems.length && wqUserResponse.pageOfItems[0];

        wqCommentHistory.forEach((record) => {
          record.profileUrl = wqUser ? wqUser.profileUrl : '';
        });

        const isUpdateWQComment =
          log.action_type === 'UPDATE' && log.version > 0 && wqCommentHistoryLength > 1;

        dialogConfig.width = '400px';
        dialogConfig.data = isUpdateWQComment
          ? [wqCommentHistory[0], wqCommentHistory[1]]
          : log.action_type === 'CREATE'
          ? [wqCommentHistory.find((record) => record.rev_type === 'ADD')]
          : [wqCommentHistory.find((record) => record.rev_type === 'DEL')];

        this.dialog.open(TaskCommentsComponent, dialogConfig);
        break;
      }
      case 'PATIENT': {
        const patientResponse = await this.patientService
          .getPatientHistory(log.entity_id, log.version)
          .toPromise();
        const patientHistory = patientResponse.data;
        const isUpdated =
          log.action_type === 'UPDATE' && log.version > 0 && patientHistory.length > 1;

        dialogConfig.width = isUpdated ? '90vw' : '45vw';
        dialogConfig.data = isUpdated
          ? [{ patient: patientHistory[1] }, { patient: patientHistory[0] }]
          : [{ patient: patientHistory[0] }];

        this.dialog.open(PatientModReviewComponent, dialogConfig);
        break;
      }
      case 'CONTACT': {
        const contactResponse = await this.contactsService
          .getHistoryByVersion(log.entity_id, log.version)
          .toPromise();
        const contactHistory = contactResponse.data;
        const modification =
          log.action_type === 'UPDATE' && log.version > 0 && contactHistory.length > 1;

        dialogConfig.width = modification ? '90vw' : '45vw';
        dialogConfig.data = modification
          ? [
              { readonly: true, contact: contactHistory[1] },
              { readonly: true, contact: contactHistory[0] },
            ]
          : [{ readonly: true, contact: contactHistory[0] }];

        this.dialog.open(ContactHistoryReviewComponent, dialogConfig);
        break;
      }
    }
  }

  openRelatedTo(type, obj) {
    const id = obj.id;
    this.dialogRef.close();
    switch (type) {
      case 'DRUG':
        this.router.navigate(['lists/drugs/edit/' + id], { relativeTo: this.activatedRoute });
        return;
      case 'PHARMACY_GROUP':
        this.router.navigate(['lists/pharmacy-groups/edit/' + id], {
          relativeTo: this.activatedRoute,
        });
        return;
      case 'PHARMACY':
        this.router.navigate(['lists/pharmacies/edit/' + id], { relativeTo: this.activatedRoute });
        return;
      case 'CLIENT':
        this.router.navigate(['lists/clients/edit/' + id], {
          queryParams: { relativeTo: this.activatedRoute, filteredView: true },
        });
        return;
      case 'FACILITY':
        this.router.navigate(['lists/facilities/edit', id], {
          queryParams: { relativeTo: this.activatedRoute, filteredView: true },
        });
        return;
      case 'DOCTOR':
        this.router.navigate(['lists/doctors/edit/' + id], {
          queryParams: { relativeTo: this.activatedRoute, filteredView: true },
        });
        return;
      case 'PATIENT':
        this.router.navigate(['lists/patients/edit', id], {
          queryParams: { viewContext: ViewContext.patients, filteredView: true },
        });
        return;
      case 'CONTACT':
        this.router.navigate(['lists/contacts/edit/' + id], {
          queryParams: { viewContext: ViewContext.contacts, filteredView: true },
        });
        return;
    }
  }
  getDate(created: any) {
    return this.datepipe.transform(created, 'yyyy-MM-dd HH:mm', 'UTC');
  }
  getRealType(type) {
    switch (type) {
      case 'FAX':
        return 'FAX';
      case 'MEETING':
        return 'Meeting';
      case 'EMAIL':
        return 'Email';
      case 'FILTERED_VIEW_SESSION':
        return 'Session';
      case 'NOTIFICATION':
        return 'Mobile Notification';
      case 'ALERT':
        return 'Mobile Alert';
    }
  }
  getApplicationName(application_id) {
    const selectedApp = this.apps.filter((app) => app.id === application_id);
    if (selectedApp) return selectedApp[0]?.name;
  }
}
